// Module
var code = "<react-component name=\"InvoicePlanMembershipsRealignment\"></react-component>\n";
// Exports
module.exports = code;